import { render, staticRenderFns } from "./CmgCustomerGreeting.vue?vue&type=template&id=c98c8040&scoped=true&lang=pug"
import script from "./cmg-customer-greeting.ts?vue&type=script&lang=ts&external"
export * from "./cmg-customer-greeting.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCustomerGreeting.vue?vue&type=style&index=0&id=c98c8040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98c8040",
  null
  
)

export default component.exports